<template>
    <PagosReportTable :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable">
        <span slot="after-filters">
          <v-tooltip bottom>
            <v-btn slot="activator" icon @click="downloadExcel" flat>
              <v-icon color="primary">far fa-file-excel</v-icon>
            </v-btn>
            <span>Descargar XLS</span>
          </v-tooltip>
        </span>
    </PagosReportTable>
</template>

<script>
import PagosReportTable from './PagosReportTable'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { paginationMixin } from '../../../mixins/paginationMixin'

export default {
  mixins: [downloadFileMixin, paginationMixin],
  data () {
    return {
      path: `pagos/jugadores/list`,
      filterPath: 'filter/pagos'
    }
  },
  components: {
    PagosReportTable
  },
  computed: {
    headers () {
      return [
        { text: 'Club', value: 'club', align: 'left', filterField: true, sortable: false },
        { text: 'Periodo', value: 'mes', align: 'left', sortable: false },
        { text: 'Apellido', value: 'playerLastName', align: 'left', sortable: false },
        { text: 'Nombre', value: 'playerFirstName', align: 'left', sortable: false },
        { text: 'Concepto', value: 'concepto', align: 'left', sortable: false },
        { text: 'Moneda', value: 'moneda', align: 'left', sortable: false },
        { text: 'Importe bruto', value: 'importeBruto', align: 'left', sortable: false, currencyField: true },
        { text: 'Importe neto', value: 'importeNeto', align: 'left', sortable: false, currencyField: true }
      ]
    },
    properties () {
      return ['club', 'mes', 'playerLastName', 'playerFirstName', 'concepto', 'moneda', 'importeBruto', 'importeNeto']
    }
  },
  methods: {
    getExcelPath () {
      return 'pagos/jugadores/xls' + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return 'pagos_jugadores'
    }
  }
}
</script>
